<template>
    <div id="departments">
        <div style="padding: 0 20px" v-loading="BOMloading">
            <!-- 表格区域 -->
            <vxe-grid ref="xGrid" :scroll-y="{ gt: 80 }" v-bind="gridOptions" class="mytable-style"
                :cell-class-name="cellClassName" @edit-disabled="editDisabledEvent" @scroll="handleScroll"
                @cell-dblclick="noEdit" @custom='customEvent' @edit-actived="editActivedEvent"
                @checkbox-all="checkboxChangeEvent" @checkbox-change="checkboxChangeEvent"
                :checkbox-config="{ checkMethod: checkboxMethod, checkStrictly: false }">
                <template #toolbar_buttons>
                    <el-button class="btn btn1" style="margin-left:0px" icon="el-icon-circle-plus-outline"
                        @click="searchAddBom = true" :disabled="!editTable || !addTableListPriv"
                        :class="!editTable || !addTableListPriv ? 'btnDisable' : ''">{{ $t("message.button.add") }}
                    </el-button>
                    <el-button class="btn btn2" icon="el-icon-delete" @click="removeCheckbox"
                        :disabled="!editTable || !removeBtnPriv"
                        :class="!editTable || !removeBtnPriv ? 'btnDisable' : ''">{{ $t("message.button.delete") }}
                    </el-button>
                    <el-button class="btn btn3" icon="el-icon-document-checked" @click="getUpdateEvent" v-if="!editShow"
                        :disabled="!editTable || !addTableListPriv"
                        :class="!editTable || !addTableListPriv ? 'btnDisable' : ''">{{ $t("message.button.save") }}
                    </el-button>
                    <el-button class="btn btn4" icon="el-icon-circle-close" @click="closeSave" v-if="!editShow"
                        :disabled="!editTable || !addTableListPriv"
                        :class="!editTable || !addTableListPriv ? 'btnDisable' : ''">{{ $t("message.button.cancel") }}
                    </el-button>
                    <el-switch style="margin-left:45px" v-model="switchValue" v-show="switchShow" active-color="#13ce66"
                        :active-text="redLine" @change="redLineSwitch" />
                </template>

                <template #getDynamic="{ row, columnIndex, column }">
                    <span v-for="(item, index) in getDynamicData(row, columnIndex - 1, column)" class="showLink"
                        :key="index" :title="item.label" @click="clax(item)"> {{ item.label }}</span>
                </template>

                <template #bottom>
                    <div class="alert-message">
                        <span class="alert-message-content">
                            <div> {{ $t('message.title.Checked') + selectRecords.length }} {{
                                $t('message.title.totalResults') + totalRecords + $t('message.title.resultsNums') }}
                            </div>
                        </span>
                    </div>
                </template>
            </vxe-grid>
        </div>

        <el-dialog v-if="searchAddBom" width='65%' class="searchAddBomList" :title="$t('message.title.add')"
            :visible.sync="searchAddBom" :close-on-click-modal="!searchAddBom" :close-on-press-escape="false">
            <searchAdd @listDbClick="addList" :creatBy='creatBy' :departmentList='departmentList'>
                <div>
                    <el-button size="small" type="primary" icon="el-icon-edit-outline" @click="addM">{{
                        $t("message.title.create") }}
                    </el-button>
                </div>
            </searchAdd>
        </el-dialog>

        <el-dialog v-if="creatNew" class="searchAddBomList" :title="$t('message.title.create')" :visible.sync="creatNew"
            :close-on-click-modal="!creatNew">
            <Create :saveUrl="saveTableUrl" :baseClass="baseClass_" :creatBy='creatBy' :departmentList='departmentList'
                :classId_="createClassId" @addToList="creatNewModel" @closeCreateNew="closeCreateNew"></Create>
        </el-dialog>
        <el-dialog v-if="cascaderShow" class="searchAddBomList" :title="$t('message.title.add')"
            :visible.sync="cascaderShow" @close="closeCascaderShow">
            <div style="height:270px;">
                <div style="margin:60px auto;padding-left:50px">
                    <el-cascader v-model="cascaderValue" :options="cascaderList" :props="cascaderProps"
                        :show-all-levels="true" size="small" ref="cascaderAddr" style="width:75%"></el-cascader>
                    <el-button size="small" type="primary" style="margin-left:10px" @click="getCascadeValue">{{
                        $t("message.button.affirm") }}
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<style>
.searchAddBomList .el-dialog__body {
    padding: 0 20px 20px 20px !important;
}

.el-table th.gutter {
    display: table-cell !important;
}

.searchAddBomList .el-carousel__container {
    height: 450px !important;
}

.link_ {
    color: #4b92ff;
    cursor: pointer;
}

.link_:hover {
    color: #4b92ff;
    cursor: pointer;
    border-bottom: 1px solid #4b92ff;
}

.mytable-style .vxe-body--column.col-red {
    text-decoration: line-through;
    color: red;
}

.mytable-style .vxe-body--column.col-red span {
    color: #000;
}

.mytable-style .vxe-body--column.col-red-text {
    color: red;
}

.mytable-style .vxe-body--column.col-red-text span {
    color: red;
}
</style>
<style scoped>
.showLink {
    color: #4b92ff;
    cursor: pointer;
    text-decoration: underline;
    margin-right: 3px;
}

.icon {
    display: inline-block;
    width: 18px;
    height: 18px;
    position: relative;
    top: 3px;
}
</style>

<script>
import searchAdd from "@/components/searchAdd.vue";
import axios from "axios";
import XLSX from "xlsx";
import FileSaver from "file-saver";
import Create from "@/components/common/Create.vue";
export default {
    name: "BOM",
    data() {
        return {
            exportDataTemp: [],//存放导出的BOM，里面的multilist以text形式存值
            searchAddBom: false, //添加窗口开关
            version: "",
            redLine: '',
            createClassId: "10101",
            creatBy: 'BOM',
            baseClass_: "501",
            saveTableUrl: "/pmdm/technology/saveTechnologyP1P2P3",
            creatNew: false,
            BOMloading: false,
            selectRecords: [],
            totalRecords: "",
            gridOptions: {
                toolbarConfig: {
                    zoom: true,
                    custom: true,
                    slots: {
                        buttons: "toolbar_buttons",
                    },
                },
                keepSource: true,
                resizable: true,
                border: true,
                highlightHoverRow: true,
                highlightCurrentRow: true,
                showHeaderOverflow: true,
                showOverflow: true,
                rowId: "id",
                height: "600",
                size: "small",
                columns: [
                    {
                        type: "checkbox",
                        width: 50,
                        fixed: null,
                    },
                ],
                data: [],
                customConfig: {
                },
                treeConfig: {
                    lazy: true,
                    children: "children",
                    hasChild: "hasChildren",
                    loadMethod: this.loadChildrenMethod,
                },
                editConfig: {
                    trigger: "dblclick",
                    mode: "row",
                    showIcon: false,
                    activeMethod: this.activeRowMethod,
                    showStatus: true,
                },
                sortConfig: {
                    trigger: "cell",
                },
                editRules: {},
            },
            editShow: false,
            editTable: true,
            loading: true,
            cols: [], //表头
            rols_text: [], //表体显示内容
            get_change_info: "", //父组件传来的值
            childsTable: [], //子列表集合
            exportedBom: [], //导出的数据
            removeBtnPriv: false, //删除按钮权限
            exportBtnPriv: false, //导出按钮权限
            addTableListPriv: false,
            finished: false,
            cascaderShow: false,
            cascaderValue: [],
            cascaderList: [],
            cascaderProps: {},
            smallWidthIds: [1003003, 1003006, 1003007, 1003008],
            seekId: '',
            seekColumns: '',
            switchValue: false,
            objId: {
                ... this.$store.state.objectId,
            },
            changeObjId: {
                changeId: this.$store.state.objectId.id,
                changeClassId: this.$store.state.objectId.classId,
                changeSubClassId: this.$store.state.objectId.subClassId,
            },
        };
    },
    mounted() { },
    components: {
        searchAdd,
        Create,
    },
    computed: {
        switchShow() {
            return !!this.$store.state.change_info.changeId;
        },

        showButton() {
            return this.$store.state.boms_table_id == 4;
        },

        itemTabInfo: function () {
            return this.tabInfo // 直接监听props里的tabInfo状态
        }
    },
    props: ["changInfoNum", 'tabInfo'],
    methods: {
        //跳转
        showDetailEvent(row) {
            const obj = {
                id: row.itemId,
                classId: row.itemClassId,
                subClassId: row.itemSubClassId,
                title: row[0]
            };
            this.getLink(obj);
            this.$store.commit("setPageRefresh");
        },
        getDynamicData(row, columnIndex, column) {
            const nCol = this.gridOptions.columns[columnIndex + 1].uiType;
            const options = this.gridOptions.columns[columnIndex + 1].editRender.options;
            const val = row[column['field']];
            if (nCol === 3) {
                const obj = options.find(i => i.value === val || i.label === val)
                return !obj ? [] : [obj]
            } else {
                if (!val) {
                    return []
                } else {
                    const list = val.map(i => {
                        return options.find(j => i === j.value || i === j.label)
                    })
                    return list
                }
            }
        },

        editActivedEvent({ row, columnIndex, column }) {
            const nCol = this.gridOptions.columns[columnIndex];
            if (nCol.listType === 3) {
                axios.get('pmdm/admin/list/getEnabledListEntryByListId?listId=' + nCol.listId).then(res => {
                    nCol.editRender.options = res.data.object.listEntries.map(i => ({ value: i.listId + '_' + i.entryId, label: i.entryValue }))
                })
            }
        },

        clax(item) {
            axios.get('pmdm/admin/list/getObjectInfoByListId?listEntryId=' + item.value).then(res => {
                const obj = { ...res.data.object, title: item.label };
                this.getLink(obj);
                this.$store.commit('setPageRefresh');
            })
        },

        redLineSwitch() {
            if (this.switchValue) {
                this.getRedLineBOM()
            } else {
                this.getBomInfo();
            }

        },

        async getRedLineBOM() {
            let obj = { ...this.$store.state.change_info }
            var obj_get = {  //获取change
                ...this.objId,
                ...obj,
                tableId: 23,
            };
            const { data: res } = await this.$http.get(`/pmdm/technology/loadTable${this.params(obj_get)}`);
            this.gridOptions.data = this.getNewRedLineTableContentData(res);
            const { listIds, listTypes, uiTypes } = res.object.table.columnInfo;
            let listEntries = res.object.table.columnInfo.listEntries
            const rows = res.object.table.rows.map(i => i.cells)
            rows.map(i => {
                i.map((m, e) => {
                    if (listTypes[e] === 3) {
                        if (uiTypes[e] == 3 && m.val) {
                            listEntries[listIds[e]] = { [m.id]: m.val };
                        }
                        if (uiTypes[e] == 4 && m.ids) {
                            const ids = m.ids.split(';')
                            const vals = m.val.split(';')
                            const obj = {}
                            ids.map((j, x) => {
                                obj[j] = vals[x]
                            })
                            listEntries[listIds[e]] = { ...listEntries[listIds[e]], ...obj };
                        }
                    }
                })
            })
            let rowTitle = this.getNewTableTitleData(res);
            const ut = [0, ...res.object.table.columnInfo.uiTypes];
            for (let k = 1; k < rowTitle.length; k++) {
                if ([3, 4].includes(ut[k]) && rowTitle[k].listType === 3) {
                    rowTitle[k].slots = {
                    };
                }
            }
            this.gridOptions.columns = rowTitle;
        },

        checkboxChangeEvent({ records }) {
            this.selectRecords = records;
        },

        closeCreateNew() {
            this.creatNew = false;
            this.searchAddBom = false;
        },

        handleScroll(e) {
            if (e.isX == true) return false;
            if (!this.finished) {
                this.BOMloading = true;
                return false;
            };
        },

        checkboxMethod({ row }) {
            return !row.hasParent;
        },

        cellClassName({ row, rowIndex, column, columnIndex }) {
            if (row.redText) {
                for (var i = 0; i < row.redText.length; i++) {
                    if (columnIndex == row.redText[i]) {
                        return "col-red-text";
                    }
                }
            } else if (row.redLine) {
                for (var i = 0; i < row.redLine.length; i++) {
                    if (columnIndex == row.redLine[i]) {
                        return "col-red";
                    }
                }
            } else {
                return "";
            }
        },

        addM() {
            this.creatNew = true;
        },

        creatNewModel(e) {
            this.creatNew = false;
            this.searchAddBom = false;
            this.addList(e);
        },

        noEdit({ row, column }) {
            if (column.editRender?.cascaderType && this.editTable) {
                this.cascaderList = column.editRender.cascadeOptions;
                let m = row[[column.property]];
                if (column.editRender.props.multiple) {
                    this.cascaderValue = m ? m.map((i) => { return this.getParentIdList(this.cascaderList, i) }) : ''
                    this.cascaderProps.multiple = true;
                } else {
                    this.cascaderProps.multiple = false;
                    this.cascaderValue = m;
                }
                this.cascaderProps.checkStrictly = true;
                this.tempData = { row, column }
                this.cascaderShow = true;
            }
        },

        customEvent({ type, $table }) {
            if (type != 'confirm') {
                return;
            }
            const currentColumns = $table.getColumns().map(i => i.property);
            const saveColumns = $table.tableFullColumn.filter(i => !currentColumns.includes(i.property)).map(i => i.property).join(';')
            let obj = {
                "baseId": 501,
                "clsId": 0,
                "subId": 0,
            };
            let seekVo = { ...obj, saveColumns, isPublic: 12, name: Date.now() + '' };
            this.seekId && Object.assign(seekVo, { id: this.seekId });
            axios.post("/search/advanced/saveSeek", { seekVo })
                .then(res => {
                    this.seekId = res.data.object.result.id;
                })
                .catch(_ => { })
        },

        getCascadeValue() {
            let row = this.tempData['row']
            let column = this.tempData['column']
            if (column.editRender.props.multiple) {
                const valueList = this.cascaderValue.map(i => i[i.length - 1])
                const labelList = this.$refs['cascaderAddr'].presentTags    // 获取label值
                let currentOptions = [];
                valueList.map((i, e) => { currentOptions.push({ 'value': i, 'label': labelList[e].text }) })
                column.editRender.options = [...column.editRender.options, ...currentOptions];
                row[[column.property]] = valueList;
            } else {
                const value = this.cascaderValue[this.cascaderValue.length - 1];
                const label = this.$refs['cascaderAddr'].presentText;   // 获取label值
                column.editRender.options.push({ 'value': value, 'label': label });
                row[[column.property]] = value;
            }
            this.closeCascaderShow();
        },

        closeCascaderShow() {
            this.cascaderShow = false;
            this.cascaderValue = [];
        },

        removeCheckbox() {  //删除
            this.$confirm(this.$t("message.confirm.deleteData"))
                .then((_) => {
                    var change_info = this.$store.state.change_info;
                    var removeRow = this.$refs.xGrid.getCheckboxRecords();
                    var del_table = [];
                    var vm = this;
                    if (removeRow.length == 0) {
                        vm.$message({
                            message: this.$t("message.tips.dele_data"),
                            type: "warning",
                        });
                        return false;
                    } else {
                        for (var i = 0; i < removeRow.length; i++) {
                            var obj = {};
                            obj.id = removeRow[i].rowId;
                            obj.childId = removeRow[i].itemId;
                            del_table.push(obj);
                        }
                        var delBomData = {
                            tableId: 23,
                            changeObjId: {
                                id: change_info.changeId,
                                classId: change_info.changeClassId,
                                subClassId: change_info.changeSubClassId,
                            },
                            technologyObjId: {
                                ... this.$store.state.objectId,
                                version: this.version,
                            },
                            deleteBom: del_table,
                        };
                        axios
                            .post("/pmdm/technology/deleteTable", delBomData)
                            .then(function (res) {
                                if (res.data.code == 200) {
                                    vm.$message({
                                        message: res.data.message,
                                        type: "success",
                                    });
                                    vm.getBomInfo();
                                    vm.selectRecords = [];
                                }
                            })
                            .catch(function (error) {
                            });
                    }
                })
                .catch((_) => { });
        },

        addList(row) {  //添加
            if (row) {
                var change_info = this.$store.state.change_info;
                let insertBom = [];
                row.map((i) => {
                    let obj = {
                        'childId': i.id,
                        '5013002': i.itemNumber,
                        '5013012': i.quantity,
                        'technologyId': this.$store.state.objectId.id,
                    };
                    insertBom.push(obj)
                })
                var updateBomData = {  //post更改的值
                    tableId: 23,
                    changeObjId: {
                        id: change_info.changeId,
                        classId: change_info.changeClassId,
                        subClassId: change_info.changeSubClassId,
                    },
                    technologyObjId: {
                        ... this.$store.state.objectId,
                        version: this.version,
                    },
                    insertBom: insertBom,
                };
                var vm = this;
                axios
                    .post("/pmdm/technology/saveTable", updateBomData)
                    .then(function (res) {
                        if (res.data.code == 200) {
                            vm.$message({
                                message: res.data.message,
                                type: "success",
                            });
                            vm.getBomInfo();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },

        closeSave() {
            this.getBomInfo();//不能用revertData（），会使getUpdateRecords（）拿不到正确的值。
        },

        getUpdateEvent() {
            var vm = this;
            var xGrid_ = this.$refs.xGrid;
            let updateRecords = this.$refs.xGrid.getUpdateRecords(); //获取修改的行
            var updateBom = [];
            if (updateRecords.length) {  //判断行内那些值有改动
                for (let i = 0; i < updateRecords.length; i++) {
                    var cols_length = this.cols;
                    for (let j = 0; j < cols_length.length; j++) {
                        var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], "" + j);
                        if (updateNewData) {
                            for (let k = 0; k < this.gridOptions.columns.length; k++) {
                                var obj = {};
                                if (cols_length[j] == this.gridOptions.columns[k].attid) {
                                    var quantity = cols_length[j];
                                    obj.id = updateRecords[i].rowId;
                                    let props = this.gridOptions.columns[k].editRender.props
                                    if (props) {  //处理多选和单选
                                        if (props.multiple) {
                                            obj[quantity] = updateRecords[i][j]?.join(";") ?? '';
                                        } else if (
                                            props.type == "datetime"
                                        ) {
                                            obj[quantity] = vm.format(
                                                updateRecords[i][j],
                                                "yyyy-MM-ddThh:mm:ss"
                                            );
                                        } else {
                                            obj[quantity] = updateRecords[i][j] ?? ''
                                        }
                                    } else {
                                        obj[quantity] = updateRecords[i][j] ?? ''
                                    }
                                    updateBom.push(obj);
                                }
                            }
                        }
                    }
                };
                var change_info = this.$store.state.change_info;
                var updateBomData = {  //post更改的值
                    tableId: 23,
                    changeObjId: {
                        id: change_info.changeId,
                        classId: change_info.changeClassId,
                        subClassId: change_info.changeSubClassId,
                    },
                    technologyObjId: {
                        ... this.$store.state.objectId,
                        version: this.version,
                    },
                    updateBom: this.arrGroup(updateBom),
                };
                axios
                    .post("/pmdm/technology/updateTable", updateBomData)
                    .then(function (res) {
                        if (res.data.code == 200) {
                            vm.$message({
                                message: res.data.message,
                                type: "success",
                            });
                            vm.getBomInfo();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },

        activeRowMethod({ row, columnIndex }) {
            return !(!this.editTable || !row.cellDisable[Number(columnIndex - 1)]);
        },

        editDisabledEvent({ row, column }) {
            this.$message.error(this.$t("message.error.noEdit"));
        },

        getListEntry(columnInfo, rows) {
            const { listIds, listTypes, uiTypes } = columnInfo;
            let listEntries = columnInfo.listEntries
            const rowList = rows.map(i => i.cells)
            rowList.map(i => {
                i.map((m, e) => {
                    if (listTypes[e] === 3) {
                        if (uiTypes[e] == 3 && m.val) {
                            listEntries[listIds[e]] = { ...listEntries[listIds[e]], [m.id]: m.val };
                        }
                        if (uiTypes[e] == 4 && m.ids) {
                            const ids = m.ids.split(';')
                            const vals = m.val.split(';')
                            const obj = {}
                            ids.map((j, x) => {
                                obj[j] = vals[x]
                            })
                            listEntries[listIds[e]] = { ...listEntries[listIds[e]], ...obj };
                        }
                    }
                })
            })
            let list = {};
            for (const i in listEntries) {
                const e = listEntries[i];
                list[i] = Object.entries(e).map(j => {
                    const [value, label] = j
                    return { value, label }
                })
            }
            return list
        },

        async getBomInfo() {
            this.$emit('refreshTab');
            this.BOMloading = true;
            var change_info = this.get_change_info || this.$store.state.change_info;
            var obj_get = {  //获取change
                ... this.$store.state.objectId,
                ...change_info,
                tableId: 23,
                page: 1,
                size: 40,
            };
            var loadTableUrl = `/pmdm/technology/loadTable${this.params(obj_get)}`;
            const {  //获取标题
                data: res,
            } = await this.$http.get(loadTableUrl);
            const { rows, columnInfo } = res.object.table;
            const listEntries = this.getListEntry(columnInfo, rows);
            this.rols_text = this.getNewTableContentData(res);
            let rowTitle = this.getNewTableTitleData(res);
            const ut = [0, ...res.object.table.columnInfo.uiTypes];
            for (let k = 1; k < rowTitle.length; k++) {
                //数字 金额 变窄
                if (this.smallWidthIds.includes(rowTitle[k].attid) || ut[k] == 7 || ut[k] == 10) {
                    rowTitle[k].minWidth = 110;
                }
                if (rowTitle[k].listId != -1) {
                    rowTitle[k].editRender.options = listEntries[[rowTitle[k].listId]]
                }

                if ([3, 4].includes(ut[k]) && rowTitle[k].listType === 3) {
                    rowTitle[k].slots = {
                        default: "getDynamic",
                    };
                }
            }
            this.gridOptions.columns = rowTitle;
            this.cols = res.object.table.columnInfo.ids;
            let depList = res.object.table.columnInfo.listEntries[10001];
            this.departmentList = Object.keys(depList).map(i => {
                return { value: i, label: depList[i] }
            })
            this.gridOptions.data = this.rols_text;
            this.exportDataTemp = this.getNewChildrenTableContentData(res);
            this.version = res.object.table.version;
            this.BOMloading = false;
            this.loadAllData();
        },

        setColumns() {
            let n = this.gridOptions.columns
                .filter((i) => this.seekColumns.split(";").includes(i.field))
                .map((i) => {
                    const column = this.$refs.xGrid.getColumnByField(i.field);
                    this.$refs.xGrid.hideColumn(column);
                });
        },

        async loadAllData() {
            var change_info = this.get_change_info || this.$store.state.change_info;
            var obj_get = {  //获取change
                ... this.$store.state.objectId,
                ...change_info,
                tableId: 23,
            };
            var loadTableUrl = `/pmdm/technology/loadTable${this.params(obj_get)}`;
            const {  //获取标题
                data: res,
            } = await this.$http.get(loadTableUrl);
            this.seekId = res.object.table.seekId;
            this.seekColumns = res.object.table.saveColumns || '';
            const { rows, columnInfo } = res.object.table;
            const listEntries = this.getListEntry(columnInfo, rows);
            this.gridOptions.columns.map(i => {
                if (i?.listId && i.listId != -1) {
                    i.editRender.options = listEntries[i.listId]
                }
            })
            let gridData = this.getNewTableContentData(res);
            this.version = res.object.table.version;
            this.totalRecords = gridData.length;
            if (res.code == 200) {
                this.finished = true;
                this.BOMloading = false;
                this.$refs.xGrid.loadData(gridData);
                this.exportDataTemp = this.getNewChildrenTableContentData(res);
            };
            this.$nextTick(() => {
                this.setColumns();
            });
        },

        async loadChildrenMethod({ row }) {
            //获取子节点
            // 异步加载子节点
            var change_info = this.get_change_info || this.$store.state.change_info;
            const { itemId, itemClassId, itemSubClassId } = row;
            var obj_get = {  //获取change
                id: itemId,
                classId: itemClassId,
                subClassId: itemSubClassId,
                changeId: row.changeId,
                changeClassId: change_info.changeClassId,
                changeSubClassId: change_info.changeSubClassId,
                tableId: 23,
            };
            var loadTableUrl = `/pmdm/technology/loadTable${this.params(obj_get)}`;
            const {
                data: res,
            } = await this.$http.get(loadTableUrl);
            var table_content_text = this.mergeColumnInfo(
                this.gridOptions.columns,
                this.getNewTableTitleData(res),
                this.getNewTableContentData(res)
            );
            const { rows, columnInfo } = res.object.table;
            const listEntries = this.getListEntry(columnInfo, rows);
            this.gridOptions.columns.map(i => {
                if (i?.listId && i.listId != -1 && listEntries[i.listId]) {
                    // i.editRender.options = [...i.editRender.options, ...listEntries[i.listId]]
                    const n = i.editRender.options.map(j => j.value);
                    listEntries[i.listId].map(j => {
                        if (!n.includes(j.value)) {
                            i.editRender.options.push(j)
                        }
                    })
                }
            })
            for (var i in table_content_text) {
                this.childsTable.push(table_content_text[i]);
                table_content_text[i].hasParent = true;
            }
            var table_content_text_export = this.mergeColumnInfo(
                this.gridOptions.columns,
                this.getNewTableTitleData(res),
                this.getNewChildrenTableContentData(res)
            );
            this.setChildrenForExport(this.exportDataTemp, table_content_text_export, row.rowId);
            return table_content_text;
        },

        setChildrenForExport(boms, children, rowId) {
            for (var i in boms) {
                if (boms[i].rowId == rowId) {
                    boms[i].children = children;
                    break;
                }
                if (boms[i].children) {
                    this.setChildrenForExport(boms[i].children, children, rowId)
                }
            }
        },

        loadUserPriv() {
            let isSuperAdmin = this.$store.state.isSuperAdmin;
            let privList = this.getUserContextPriv().filter(i => i.classId == this.$store.state.objectId.subClassId).map(j => j.type);
            this.addTableListPriv = isSuperAdmin || privList.includes(3);
            this.removeBtnPriv = isSuperAdmin || privList.includes(4);
            this.exportBtnPriv = isSuperAdmin || privList.includes(12);
        },
    },
    created() {
        const { changeInfoNum = '[{}]' } = this.$route.query;
        const arr = JSON.parse(changeInfoNum)
        this.editTable = arr.length == 1;
        this.getBomInfo();
        this.loadUserPriv();
        this.$nextTick(() => {
            this.setColumns();
        });
        this.redLine = this.$t("message.title.redLine"),
            setTimeout(() => {
                this.loading = false;
            }, 500);
    },
    props: ["changeValue"],
    watch: {
        "$store.state.setObjID": function (val) {
            this.reload();
        },
        changeValue: function (value) {
            this.get_change_info = value;
            this.getBomInfo();
            this.switchValue = false;
        },
        "$store.state.boms_table_id": function (val) {
            this.getBomInfo();
        },
    },
};
</script>